



















import {Component, Vue, Emit, Prop} from 'vue-property-decorator';
import IntervalDateTimeSelect from '@c/IntervalDateTimeSelect.vue';
import {DateTimeInterval} from '@u/dateTimeItervalUtils';
import SelectField from '@c/controls/selectControls/SelectField.vue';
import ReportUploadButton from '@c/ReportUploadButton.vue';
import nodeModule from '@/store/modules/entities/nodeModule';

@Component({components: {IntervalDateTimeSelect, SelectField, ReportUploadButton}})
export default class ServiceSettingsSelectBox extends Vue {
  currentDateTimeInterval!: DateTimeInterval;

  setDateTimeInterval(currentDateTimeInterval: DateTimeInterval) {
    this.currentDateTimeInterval = currentDateTimeInterval;
  }

  @Prop({required: false, default: false})
  isShowSaveReportButton!: boolean;

  @Emit('getData')
  public onClick(): {machine: any; dateInterval: DateTimeInterval} {
    return {machine: this.selectedMachine, dateInterval: this.currentDateTimeInterval};
  }

  // Выбранный станок
  selectedMachine = {name: ''};

  // Загрузка станков
  async loadMachines() {
    await nodeModule.fetchAll();
    return [...nodeModule.machines];
  }
}
